module.exports = __webpack_public_path__ + "media/swiper-video.666821e3.mp4";